<template>
  <div class="modal">
    <div class="modal-container">
      <transition-group tag="div" name="modal-list" class="modal-list">
        <div class="modal-block" v-for="(modal) in modals" :key="modal.id">
          <div v-if="modal.overlay !== false" class="modal-overlay"></div>
          <div class="modal-content-container" :class="modal.type || 'top'" @click="e => closeModal(modal, 'overlay')">
            <div
              class="modal-content-block col-block width-full"
              :class="{ active: modal.active }"
              :style="modal.style"
              @click.stop
            >
              <component
                :is="modal.action"
                :params="modal.params"
                @closeModal="response => closeModal(modal, response)"
              ></component>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import toast from '@/components/dailog/toast.vue'

export default {
  components: {
    toast
  },
  data () {
    return {
      modals: []
    }
  },
  computed: {
    ...mapGetters([
      'modal'
    ])
  },
  watch: {
    '$route' () {
      this.modals = []
    },
    'modal' (nv) {
      if (nv) {
        let id = (new Date()).getTime() + ''
        this.modals.push({
          ...nv,
          id: id
        })
      } else {
        this.modals = []
      }
    }
  },
  methods: {
    async closeModal (modal, response) {
      let result = await (modal.callback || (() => true))(response)
      if (result !== false) {
        let index = this.modals.indexOf(this.modals.find(m => m.id === modal.id))
        this.modals.splice(index, 1)
      }
    }
  }
}
</script>
